module.exports = __webpack_public_path__ + "img/galeria-captores-3.570581ed.png";